<template>
  <div class="rightContent">
    <div class="right-con">
      <!--创建答题-->
      <el-scrollbar style="height: 100%">
        <div class="questionnaire-new">
          <el-form
            label-position="right"
            ref="addAnswer"
            :model="ruleForm"
            :rules="rules"
            class="addAnswerFrom"
          >
            <template>
              <answerList
                :answer="answer"
                :serial="answer.options"
                :title="answer.title"
                :correct="answer.correct"
                @changeOptions="changeOptions"
                @titleChange="titleChange"
                ref="answerList"
              />
            </template>
          </el-form>
        </div>
      </el-scrollbar>
    </div>
    <div class="bottom-bar">
      <div class="questionnaire-control">
        <div class="new add-control">
          <div>
            <el-upload
              class="upload-demo"
              :action="uploadUrl"
              :on-success="uploadSuccess"
              :headers="headersObj"
              :on-error="uploadError"
              :file-list="fileList"
              :show-file-list="false"
              accept=".xlsx, .xls"
            >
              <a class="link-blue" href="javascript:;">{{ $t('addOrEdit.导入答题卡') }}</a>
            </el-upload>
            <a
              class="link-download"
              href="javascript:;"
              @click="downloadFunc"
              v-if="ruleForm.paperType != 1"
              ><i class="icon icon-import"></i>{{ $t('addOrEdit.下载答题模板') }}</a
            >
            <a class="link-blue save-blue" href="javascript:;" @click="submeAnswer">{{
              $t('addOrEdit.保存答题卡')
            }}</a>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :title="$t('addOrEdit.答题导入')"
      :visible.sync="dialogVisible"
      width="30%"
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <p class="title">{{ $t('addOrEdit.以下答题导入错误') }}</p>
      <p class="errorStyle" v-for="(item, index) in errorList" :key="index">
        {{ item }}
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="dialogVisible = false">{{
          $t('addOrEdit.确定')
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import axios from 'axios';
import { getToken } from '@/utils/auth';
import answerList from '../answer/answerList.vue';
import { addAnswerSheetApi, updateAnswerSheetApi } from '@/api/liveRequest/answerApi';
export default {
  components: {
    answerList
  },
  inject: ['questionThis'],
  props: {
    actionTabsObj: {
      type: Object,
      default: null
    },
    showInfoState: {
      type: Boolean,
      default: false
    },
    editPaper: {
      type: Object,
      default: () => {}
    },
    edit: {
      type: Boolean,
      default: false
    },
    editableTabs: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      addAnswerTitle: '',
      // rules: {
      //   title: [{ required: true, message: this.$t('addOrEdit.不能为空'), trigger: "blur" }],
      // },
      options: [
        {
          label: this.$t('addOrEdit.单选'),
          value: 0
        },
        {
          label: this.$t('addOrEdit.多选'),
          value: 1
        },
        {
          value: 3,
          label: this.$t('addOrEdit.评分')
        },
        {
          value: 4,
          label: this.$t('addOrEdit.投票')
        }
      ],
      answerList: [],
      loadingState: false,
      fileList: [],
      uploadUrl: `${config.cpp}handler/v2/answerSheet/upload`,
      isShowMove: null,
      headersObj: {
        token: getToken() || this.$store.getters.liveToken
      },
      isShowDelTitle: false,
      isShowMoveUp: false,
      isShowMoveDown: false,
      paperId: 0,
      dialogVisible: false,
      errorList: [],
      ruleForm: {
        title: ''
      },
      forceAnswer: false,
      answer: {
        choose: 0,
        title: '',
        options: [
          {
            number: 'A',
            item: '',
            successState: false
          },
          {
            number: 'B',
            item: '',
            successState: false
          }
        ],
        correct: []
      }
      //answerTitle: ""
    };
  },
  computed: {
    liveToken() {
      return this.$store.getters.liveToken;
    },
    rules() {
      return {
        title: [{ required: true, message: this.$t('addOrEdit.不能为空'), trigger: 'blur' }]
      };
    }
  },
  created() {},
  watch: {
    editPaper: {
      immediate: true,
      handler(value) {
        if (this.edit) {
          console.log(value, 'paperEdit watch');
          this.paperId = value.webcastAnswerSheetId;
          this.ruleForm.title = value.answerSheetTitle;
          let choose = 0;
          if (value.questionType === '多选') {
            choose = 1;
          }
          let qusetion = {
            choose: choose,
            title: value.title,
            options: value.options,
            correct: value.rightAnswers
          };
          this.answer = qusetion;
          this.$nextTick(() => {
            this.$refs.answerList.forceAnswer = value.forceAnswer;
          });
        } else {
          let obj = {
            choose: 0,
            title: '',
            options: [
              {
                number: 'A',
                item: '',
                successState: false
              },
              {
                number: 'B',
                item: '',
                successState: false
              }
            ],
            correct: []
          };
          this.answer = obj;
        }
      }
    }
  },
  methods: {
    /**下载模板 */
    downloadFunc() {
      console.log('downloadFunc');
      axios({
        url: `${config.cpp}handler/v1/file/excel/template/QuestionTemplate`,
        responseType: 'arraybuffer',
        method: 'get'
      })
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', this.$t('addOrEdit.答题模板') + '.xlsx');
          document.body.appendChild(link);
          link.click();
        })
        .catch((err) => {
          console.log(err);
          this.$message.error(this.$t('addOrEdit.文件下载失败'));
        });
    },
    /**文件上传成功 */
    uploadSuccess(res) {
      if (res.code === 200) {
        this.$message.success(this.$t('addOrEdit.导入成功'));
        this.$emit('refreshList', true);
      } else {
        this.$message.error(
          this.$t('addOrEdit.导入的数据错误，导入失败，请检查导入内容的格式是否正确')
        );
      }
    },
    /**导入失败 */
    uploadError() {
      this.$message.error(this.$t('addOrEdit.导入失败'));
    },
    hovers(index) {
      this.isShowMove = index;
    },
    removeHove() {
      this.isShowMove = null;
    },
    titleChange(title) {
      console.log(title, 'title list');
      //this.answerTitle = title;
    },
    submeAnswer() {
      console.log(this.$refs.answerList.answerTitle, '题干');
      let flag = true;
      if (this.$refs.answerList.answerTitle === '') {
        this.$message.error(this.$t('addOrEdit.请输入题干'));
        flag = false;
        return;
      }
      let flagOptions = true;
      console.log(this.answer.options, '选项');
      this.answer.options.forEach((option) => {
        if (option.item === '') {
          flagOptions = false;
        }
      });
      if (!flagOptions) {
        this.$message.error(this.$t('addOrEdit.请输入选项'));
        return;
      }
      this.answer.options.sort(function (a, b) {
        console.log(a.number.charCodeAt() - b.number.charCodeAt());
        return a.number.charCodeAt() - b.number.charCodeAt();
      });
      if (flag) {
        let tempObj = {
          answerSheetTitle: this.$refs.answerList.answerTitle,
          title: this.$refs.answerList.answerTitle,
          questionType: this.$refs.answerList.choose,
          options: this.answer.options
        };
        if (this.$refs.answerList.choose === 0) {
          tempObj.rightAnswers = [this.$refs.answerList.correctTips];
          if (this.$refs.answerList.correctTips === '') {
            this.$message.error(this.$t('addOrEdit.请勾选正确答案'));
            return;
          }
        }
        if (this.$refs.answerList.choose === 1) {
          tempObj.rightAnswers = this.$refs.answerList.correctChecked;
          console.log(this.$refs.answerList.correctChecked);
          if (this.$refs.answerList.correctChecked.length === 0) {
            this.$message.error(this.$t('addOrEdit.请勾选正确答案'));
            return;
          }
        }
        if (this.edit) {
          this.updateAnswerSheet(tempObj);
        } else {
          this.addOrEditQusetionnaireFunc(tempObj);
        }
      }
    },
    /**编辑答题卡 */
    updateAnswerSheet(data) {
      data.webcastAnswerSheetId = this.paperId;
      const forceAnswer = { forceAnswer: this.$refs.answerList.forceAnswer }; //新增强制配置项
      updateAnswerSheetApi({ ...data, ...forceAnswer }, this.liveToken)
        .then((res) => {
          console.log(res, 'res_updateAnswerSheetApi');
          if (res.code === 200) {
            this.$message.success(this.$t('addOrEdit.答题卡保存成功'));
            // this.$emit('refreshList', true);
            // this.$refs['addAnswer'].resetFields();
            this.resumeDefault();
          } else if (res.code == 4001) {
            this.$message.warning(this.$t('addOrEdit.该答题卡内容已更新，请刷新后再试'));
          }
          this.loadingState = false;
        })
        .catch((err) => {
          console.log(err, 'err_updateAnswerSheetApi');
          this.loadingState = false;
        });
    },
    addOrEditQusetionnaireFunc(tempObj) {
      let params = tempObj;
      console.log(params, 'params');
      console.log(this.$refs.answerList.forceAnswer, 'forceAnswer');
      if (this.editableTabs.length >= 30)
        return this.$message.error(`${this.$t('addOrEdit.CreateSize')}`);
      const forceAnswer = { forceAnswer: this.$refs.answerList.forceAnswer }; //新增强制配置项
      addAnswerSheetApi({ ...params, ...forceAnswer }, this.liveToken)
        .then((res) => {
          //this.loadingState = false;
          if (res.code === 200) {
            this.$message({
              message: this.$t('addOrEdit.答题卡保存成功'),
              type: 'success'
            });
            this.resumeDefault();
          } else {
            this.$message.warning(res.msg);
          }
        })
        .catch(() => {
          this.loadingState = false;
        });
    },
    changeOptions(options) {
      console.log(options, '切换后的选项');
      this.answer.choose = options.choose;
      this.answer.options = [
        {
          number: 'A',
          item: '',
          successState: false
        },
        {
          number: 'B',
          item: '',
          successState: false
        }
      ];
      this.answer.correct = [];
      this.$forceUpdate();
      console.log('修改后的', this.answer);
    },
    // 恢复默认
    resumeDefault() {
      this.$emit('refreshList', true);
      let obj = {
        choose: 0,
        title: '',
        options: [
          {
            number: 'A',
            item: '',
            successState: false
          },
          {
            number: 'B',
            item: '',
            successState: false
          }
        ],
        correct: []
      };
      this.answer = obj;
      this.$refs.answerList.answerTitle = '';
      this.$refs.answerList.forceAnswer = false; //答题添加成功后，将强制更新变为默认false
      this.$refs['addAnswer'].resetFields();
      this.$forceUpdate();
    }
  }
};
</script>
<style scoped lang="scss">
.rightContent {
  height: 480px;
  width: 100%;
  background: $back-answer-color;
  padding: 20px 0 20px 0;
}
.questionnaire-new {
  margin-left: 20px;
}

.inputLong ::v-deep .el-input__inner {
  padding: 0 57px 0 15px;
  border-color: #525366;
}

.right-con {
  height: 430px;
}

.addInputLongItem ::v-deep .el-input__inner {
  padding: 0 57px 0 15px;
  border-color: #525366;
}

.left-nav ::v-deep .el-scrollbar__wrap {
  overflow-x: hidden;
}

.right-con ::v-deep .el-scrollbar__wrap {
  overflow-x: hidden;
}

.answerTabs ::v-deep .is-left {
  font-size: 12px;
}

.bottom-link {
  width: 140px;
  position: absolute;
  bottom: 16px;
  background-color: #f1f1f1;
  text-align: center;
  font-size: 12px;
}

.answerDialog ::v-deep .el-dialog .el-dialog__body {
  padding: 0px;
  height: 520px;
}

.answerDialog ::v-deep .el-dialog__header {
  background: #f1f1f1;
}

.answerDialog ::v-deep .el-dialog__body .el-tabs--left .el-tabs__header.is-left {
  width: 140px;
  height: 520px;
  background: #f1f1f1;
}

.answerDialog ::v-deep .el-dialog__body .el-tabs--left.el-tabs--card .el-tabs__item.is-left {
  height: 48px;
  line-height: 48px;
  text-align: center;
}

.answerDialog
  ::v-deep
  .el-dialog__body
  .el-tabs--left.el-tabs--card
  .el-tabs__item.is-left.is-active {
  border: 0px;
  background: #ffffff;
}

.answerDialog ::v-deep .el-tabs__header .el-tabs__nav-wrap .el-tabs__nav-scroll .el-tabs__nav {
  border: 0px;
}

.addAnswerFrom ::v-deep .el-form-item__label {
  font-size: 12px;
}

.addAnswerFrom ::v-deep .el-form-item__content {
  line-height: 0px;
}

.addAnswerFrom {
  padding-right: 26px;
  ::v-deep .el-form-item {
    display: flex;
  }
}

.addInputLong {
  width: 86%;
  text-align: center;
}

.addMoreanswer .input-title-sm {
  width: 80px;
}

.link-blue {
  color: $bule-color;
  text-decoration: none;
  display: inline-block;
  height: 28px;
  line-height: 28px;
  padding: 0 15px;
  border-radius: 8px;
  margin-right: 15px;
  border: 1px solid $bule-color;
}

.save-blue {
  background-color: rgba(57, 134, 238, 0.5);
  color: $white-color !important;
  float: right;
}

.addMoreanswer {
  background: $bule-color;
  color: $white-color !important;
  width: 260px;
}

.bottom-bar {
  padding-top: 20px;
  margin-left: 20px;
}

.upload-demo {
  display: inline-block;
}

.more-answer {
  padding: 10px;
}

::v-deep .el-select-dropdown {
  background: $back-answer-color;
}

.answers {
  position: relative;
}

.icon {
  display: inline-block;
  height: 18px;
  width: 18px;
  vertical-align: middle;
  background-repeat: no-repeat;
  margin-left: 10px;
  color: $white-color;
  position: absolute;
  top: 14px;
  right: 0;
}

.icon-clear {
  background: url(../../../svg/icon/icon-clear.svg);
}

.icon-move-up {
  background: url(../../../svg/icon/icon-move-down.svg);
  right: 22px;
}

.icon-move-down {
  background: url(../../../svg/icon/icon-move-up.svg);
  right: 48px;
}

// ::v-deep .el-form-item {
//   width: 90%;
// }

.add-control {
  text-align: left;
}
.link-download {
  color: $bule-color;
  text-decoration: none;
  font-size: 12px;
  &:hover {
    text-decoration: underline;
  }
}
[data-theme='Orange'] .link-download {
  color: #f89b33;
}
/* 滚动条的宽度 */
::v-deep .el-textarea__inner::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

/* 滚动条轨道的样式 */
::v-deep .el-textarea__inner::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0);
  width: 4px;
  background: transparent;
}

/* 滚动条的样式 */
::v-deep .el-textarea__inner::-webkit-scrollbar-thumb {
  width: 5px;
  margin: auto;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0);
  background: transparent;
  border-radius: 10px;
}
// [data-theme='Orange'] .answerList ::v-deep .el-textarea__inner,
// .answerList ::v-deep .el-input__inner,
// .answerList ::v-deep .el-checkbox__inner,
// .answerList ::v-deep .el-radio__inner {
//   background: #fff !important;
// }
</style>
